import useGetResults from "actions/quiz/useGetResults";
import Slider from "./Slider/Slider";
import Fade from "components/UI/Animations/Fade/Fade";
import { useNavigate } from "@tanstack/react-router";
import useJoyStickNavigation, {
  joystickEvent,
} from "hooks/UseJoyStickNavigation";
import { useContext, useEffect } from "react";
import { QuizContext } from "context/QuizContext";
import { useQueryClient } from "@tanstack/react-query";

export default function DataScreenSaver() {
  const { data: questionsSlides } = useGetResults();
  const { setCategoryIndex, setQuestionIndex } = useContext(QuizContext);

  const queryClient = useQueryClient();

  useEffect(() => {
    setCategoryIndex(0);
    setQuestionIndex(0);

    const intervalId = setInterval(() => {
      //assign interval to a variable to clear it.
      queryClient.invalidateQueries({ queryKey: ["results"] });
    }, 300000);

    return () => clearInterval(intervalId); //This is important
  }, []);

  const navigate = useNavigate();

  const handleJoyStick = (event: joystickEvent) => {
    if (event === "enter") {
      navigate({ to: "/" });
    }
  };

  useJoyStickNavigation(handleJoyStick);

  return (
    <Fade>{questionsSlides ? <Slider slides={questionsSlides} /> : null}</Fade>
  );
}
